'use strict';

module.exports = require('./index').default;


//////////////////
// WEBPACK FOOTER
// ./~/requestanimationframe-timer/dist/cjs.js
// module id = 1870
// module chunks = 1